import {SET_FILL} from "../constants/action-types";
import Mediator from "../services/Mediator";

export const setFillForPath = (value) => (dispatch) => {
  dispatch({
    type: SET_FILL
  });
  Mediator.setFillForActivePath(value);
};
